SideCartDirective.$inject = ['$timeout', 'storage', 'api', '$rootScope', '_cart', '_analytics'];
function SideCartDirective($timeout, storage, api, $rootScope, _cart, _analytics) {
    return {
        restrict: 'E',
        scope: {
            isOpen: '='
        },
        template: require('./views/side-cart-directive.html'),
        link: function (scope, element, attrs) {
            scope.showCart = storage.getItem('side_cart');
            scope.isOpen = scope.showCart;
            scope.loading = false;
            scope.currency = $rootScope.currency;
            $rootScope.$watch('currency_value', function (value) {
                scope.currency = $rootScope.currency_value;
            });
            scope.show_vat = $rootScope.show_vat;
            $rootScope.$watch('show_vat', function (value) {
                scope.show_vat = $rootScope.show_vat;
            });
            scope.show_prices = $rootScope.show_prices;
            $rootScope.$watch('show_prices', function (value) {
                scope.show_prices = $rootScope.show_prices;
            });
            scope.$on('sideCartToggle', function (event, data) {
                event.preventDefault();
                $timeout(function () {
                    scope.showCart = data.isOpen;
                    scope.isOpen = scope.showCart;
                }, 0);
            });
            scope.remove = function (product) {
                _cart.remove(product).then(function (response) {
                    scope.cart_items = response.items;
                    countTotalPrices();
                    _cart.updateTotal();
                    scope.$emit('remove_from_cart', { _id: product.product_id });
                }, function (error) {
                    console.log(error);
                });
            };
            scope.setQuantity = function (product) {
                // Enforce max 1 quantity for damaged products
                if (product && product.damaged_product && product.quantity > 1) {
                    product.quantity = 1;
                }
                _cart.update(product, { quantity: product.quantity })
                    .then(function (response) {
                    scope.cart_items = response.list.items;
                    countTotalPrices();
                    _cart.updateTotal();
                    scope.$emit('change_quantity_from_cart', { _id: product.product_id, quantity: product.quantity });
                }, function (error) {
                    console.log('error');
                });
            };
            function countTotalPrices() {
                _.each(scope.cart_items, function (p, index) {
                    p.price_show = p.quantity * p.price;
                    p.vat_total = (p.price_show * p.vat) / 100;
                    p.subtotal = p.price_show + p.vat_total;
                });
            }
            function getCart() {
                scope.loading = true;
                api.get('/b2b/cart/').then(function (response) {
                    scope.cart_items = response.items;
                    countTotalPrices();
                    scope.loading = false;
                }, function (error) {
                    console.log(error);
                    scope.loading = false;
                });
            }
            $rootScope.$watch('cart_total_quantity', function (val) {
                getCart();
            });
        }
    };
}
angular.module('rinca.core.directives.sidecart', [])
    .directive('rcSidecart', SideCartDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/SideCartDirective.js
// module id = 316
// module chunks = 0